import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  BehaviorSubject,
  catchError,
  lastValueFrom,
  map,
  Observable,
  Subject,
  throwError,
} from 'rxjs';
import { ApiService } from './api.service';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  public AtSymbol: string = '@';
  private selectedCommunity: Subject<any> = new Subject();
  private selectedPortfolio: Subject<any> = new Subject();
  private portfolioSubject: Subject<any> = new Subject();
  public resetSubject: Subject<null> = new Subject();
  public portfolioId: string[] = [];
  public communityId: string[] = [];
  public month: any;
  public year: any;
  public endMonth: any;
  public endYear: any;
  public rejectionTitle: string;
  public complianceStatus: string[] = [];
  public occupancyStatus: string[] = [];
  public monthYear: Date = new Date();
  public isCashSelectedInAccounting: any = null;
  public docRotationDegree = 0;
  public selectedInvoiceStatus = null;
  private residentIds: string[] = [];
  private chartType: string | null = null;
  private invoiceStatus: boolean = false;
  private subject = new Subject<any>();
  private Importsubject = new Subject<any>();
  public selectedPortfolioName: string;
  public selectedPortfolioForAccounting: string = null;
  public selectedCommunityForAccounting: string = null;
  public isDashboardActive: boolean = false;
  public isFromVacantUnitsChart: boolean = false;
  public goBackToInvoicePaymentScreen1: boolean = false;
  selectedStartMonthYearValueFromInvoice: Date;
  selectedEndMonthYearValueFromInvoice: Date;
  rangeStartDate: string = null;
  rangeEndDate: string = null;
  leaseStartDate: string = null;
  leaseEndDate: string = null;
  selectedCalculationTypes: string[] = [];
  partnershipListing: any;
  basePartshipListing: any;
  clientListing: any;
  baseMarketingListing: any;
  private _postRequest: any;
  public requirementReferenceId: string | null = null;
  public selectedResidentValue: any = null;
  invoiceMethodPorfolio: string = null;

  fieldValidationState: { [key: string]: boolean | null } = {
    LIABILITY_AMOUNT: null,
    PO_BOX: null,
    ZIPCODE: null,
    POSTAL_CODE: null,
  };
  invoiceSearchedMonth: number;
  invoiceSearchedYear: number;

  private readMessageSource = new BehaviorSubject<number>(0);
  private unreadMessageSource = new BehaviorSubject<number>(0);

  readMessage$ = this.readMessageSource.asObservable();
  unreadMessage$ = this.unreadMessageSource.asObservable();

  public currentVersion: string = '5.2.0';

  private refreshCommunityRequirementsSource = new Subject<{
    referenceId?: string;
    isFromLoad?: boolean;
  }>();

  invoiceStatuses: { value: string | null; label: string }[] = [
    { value: null, label: 'All Invoice Status' },
    { value: 'PAID', label: 'Paid' },
    { value: 'UNPAID', label: 'Unpaid' },
    { value: 'OVERPAID', label: 'Over paid' },
    { value: 'PARTIAL_PAID', label: 'Partial paid' },
  ];

  constructor(
    private toastr: ToastrService,
    public apiService: ApiService,
  ) {}
  public previousAmountSettlementStartMonth: number;
  public previousAmountSettlementStartYear: number;
  public InvoiceNumberForAccountingScreen: string | null = null;

  private isNewComplianceChargeFormSubmittedSource = new BehaviorSubject<boolean>(false);
  isNewComplianceChargeFormSubmitted$ =
    this.isNewComplianceChargeFormSubmittedSource.asObservable();

  updateIsNewComplianceChargeFormSubmitted(value: boolean) {
    this.isNewComplianceChargeFormSubmittedSource.next(value);
  }

  private partnersSource = new BehaviorSubject<string[]>([]);
  partners$ = this.partnersSource.asObservable();

  private clientsSource = new BehaviorSubject<string[]>([]);
  clients$ = this.clientsSource.asObservable();

  setPartners(partners: string[]): void {
    this.partnersSource.next(Array.isArray(partners) ? partners : []);
  }

  setClients(clients: string[]): void {
    this.clientsSource.next(Array.isArray(clients) ? clients : []);
  }

  getPartners(): string[] {
    return this.partnersSource.getValue();
  }

  getClients(): string[] {
    return this.clientsSource.getValue();
  }

  setPostRequest(value: any): void {
    this._postRequest = value;
  }

  // Getter
  getPostRequest(): any {
    return this._postRequest;
  }

  get EmailAtSymbol(): string {
    return this.AtSymbol;
  }
  get getResidents(): string[] {
    return this.residentIds;
  }
  set setResidents(chartType: string[]) {
    this.residentIds = chartType;
  }

  get getCurrentVersion(): string {
    return this.currentVersion;
  }

  set setCurrentVersion(version: string) {
    this.currentVersion = version;
  }

  get getChartType(): string | null {
    return this.chartType;
  }
  set setChartType(chartType: string | null) {
    this.chartType = chartType;
  }

  set setInvoiceStatus(status: boolean | false) {
    this.invoiceStatus = status;
  }

  get getInvoiceStatus(): boolean {
    return this.invoiceStatus;
  }

  get selectedCommunitySubject(): Subject<any> {
    return this.selectedCommunity;
  }

  get selectedCommunityObservable(): Observable<any> {
    return this.selectedCommunity.asObservable();
  }
  get selectedPortfolioSubject(): Subject<any> {
    return this.selectedPortfolio;
  }

  get selectedPortfolioObservable(): Observable<any> {
    return this.selectedPortfolio.asObservable();
  }
  get sPortfolioSubject(): Subject<any> {
    return this.portfolioSubject;
  }
  get sPortfolioObservable(): Observable<any> {
    return this.portfolioSubject.asObservable();
  }

  sendMessage(length: number) {
    this.subject.next(length);
  }

  onMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  sendResidentCount(length: number) {
    this.subject.next(length);
  }

  onResidentCount(): Observable<any> {
    return this.subject.asObservable();
  }

  sendApplicantCount(length: number) {
    this.subject.next(length);
  }

  sendEPolicyCount(length: number) {
    this.subject.next(length);
  }

  onGetUserList(): Observable<any> {
    return this.subject.asObservable();
  }
  sendUserList() {
    this.subject.next(null);
  }
  onOpenImportModal(): Observable<any> {
    return this.Importsubject.asObservable();
  }
  ImportModal() {
    this.Importsubject.next(null);
  }

  checkDateFormat(event: any, isFirstOfMonth: boolean = false): boolean {
    let x = event?.target?.value;
    let isValidDate = false;

    if (x?.length !== 0) {
      let dateParts = x?.split('/');

      if (
        dateParts?.length === 3 &&
        dateParts[0]?.length <= 2 &&
        Number(dateParts[0]) >= 1 &&
        Number(dateParts[0]) <= 12 &&
        dateParts[1]?.length <= 2 &&
        Number(dateParts[1]) >= 1 &&
        Number(dateParts[1]) <= 31 &&
        dateParts[2]?.length === 4
      ) {
        isValidDate = true;

        if (isFirstOfMonth && Number(dateParts[1]) !== 1) {
          isValidDate = false;
        }
      }
    }
    return isValidDate;
  }

  checkDateFormatOnPaste(event: ClipboardEvent, isFirstOfMonth: boolean = false): void {
    const pastedData = event.clipboardData?.getData('text') || '';

    const tempInput = document.createElement('input');
    tempInput.value = pastedData;

    if (!this.checkDateFormat({ target: tempInput }, isFirstOfMonth)) {
      event.preventDefault();
    }
  }

  checkDateFormatOnInput(event: any): void {
    const isValid = this.checkDateFormat(event);
    if (!isValid) {
      event.target.value = '';
    }
  }

  numberOnlyOnPaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text') || '';

    if (!/^\d+$/.test(pastedData)) {
      event.preventDefault();
    }
  }

  noDotsValidator(control: any) {
    const value = control.value ? control.value.toString() : '';
    if (value.includes('.')) {
      return { containsDot: true };
    }
    return null;
  }

  noSpecialCharactersValidator(control: any) {
    const specialCharacterPattern = /[^a-zA-Z0-9\s]/;
    const value = control.value ? control.value.toString() : '';
    if (specialCharacterPattern.test(value)) {
      return { containsSpecialCharacters: true };
    }
    return null;
  }

  noSpecialCharactersForDateInputs(control: any) {
    const specialCharacterPattern = /[^0-9/]/;
    const value = control.value;
    if (!value) {
      return null;
    }
    if (Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value)) {
      return null;
    }
    const dateFormatPattern = /^\d{2}\/\d{2}\/\d{4}$/;
    if (typeof value === 'string' && dateFormatPattern.test(value)) {
      return null;
    }
    if (typeof value === 'string' && specialCharacterPattern.test(value)) {
      return { containsSpecialCharacters: true };
    }

    return null;
  }

  formatAmount(
    amount: number | string,
    minimumFractionDigits: number = 0,
    maximumFractionDigits: number = 2,
  ): string {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
    }).format(Number(amount) || 0);
  }

  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      return false;
    }
    return true;
  }

  private readonly specificSpecialCharsRegex = /[/\\?*[\]:]/;

  hasSpecificSpecialChars(value: unknown): boolean {
    const text = value == null ? '' : value.toString();
    return this.specificSpecialCharsRegex.test(text);
  }

  validateNoSpecialChars(
    value: unknown,
    fieldName: string = 'portfolio or community name',
  ): boolean {
    if (this.hasSpecificSpecialChars(value)) {
      this.toastr.error(`Special characters /, \\, ?, *, [, ], : are not allowed in ${fieldName}`);
      return false;
    }
    return true;
  }

  charOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122) ||
      charCode === 8 ||
      charCode === 32 ||
      charCode === 9
    ) {
      return true;
    }
    return false;
  }

  allowDateCharactersOnly(event: KeyboardEvent): void {
    const allowedRegex = /^[0-9\/]*$/;
    if (!allowedRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  allowNumericDigitsOnlyOnKeyUp(event: any) {
    if (!event) {
      return false;
    }
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 47 || charCode > 57)) {
      return false;
    }
    return true;
  }
  convertIntToPositive(number: number) {
    return Math.abs(number);
  }

  formatNumber(value: any): string {
    if (value === null || value === undefined || isNaN(Number(value))) {
      return '';
    }

    const num = Number(value);

    if (num < 0) {
      return Math.abs(num).toFixed(2);
    }

    return num.toFixed(2);
  }

  getTimeAgo(created: string): string {
    const currentTime = new Date();
    const createdTime = new Date(created);
    const timeDifference = currentTime.getTime() - createdTime.getTime();

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) {
      return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
    } else if (minutes < 60) {
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else if (hours < 24) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (days < 7) {
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (weeks < 4) {
      return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    } else if (months < 12) {
      return `${months} month${months > 1 ? 's' : ''} ago`;
    } else {
      return `${years} year${years > 1 ? 's' : ''} ago`;
    }
  }

  updateMessages(readMessage: number, unreadMessage: number): void {
    this.readMessageSource.next(readMessage);
    this.unreadMessageSource.next(unreadMessage);
  }

  formatDateToSimpleStringForCompliance(ISODate: any): string | undefined {
    if (!ISODate) {
      return;
    }
    const date = new Date(ISODate);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
  }

  FormatDateToSimpleString(ISODate: any) {
    if (!ISODate) return;

    const d = new Date(ISODate);

    // optional: handle invalid date inputs
    if (isNaN(d.getTime())) return;

    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  }

  async checkLimitOfLiability(
    fieldValue: any,
    communityId: string,
    fieldType: string,
  ): Promise<boolean> {
    try {
      const response = await lastValueFrom(
        this.apiService.post({
          path: 'core/policy/validate-policy',
          data: { communityId, fieldValue, fieldType },
          isAuth: true,
        }),
      );
      return response?.data ?? false;
    } catch (error) {
      return false;
    }
  }

  async validateField(event: Event, communityId: string, fieldType: string): Promise<void> {
    const target = event.target as HTMLInputElement;
    if (!target || target.value.trim() === '') {
      return;
    }

    let fieldValue: number | string = Number(target.value.replace(/,/g, ''));
    if (isNaN(fieldValue as number)) {
      return;
    }

    if (fieldType !== 'LIABILITY_AMOUNT') {
      fieldValue = target.value.trim();
    }

    this.fieldValidationState[fieldType] = await this.checkLimitOfLiability(
      fieldValue,
      communityId,
      fieldType,
    );
  }

  resetFieldValidationState(): void {
    this.fieldValidationState = {
      LIABILITY_AMOUNT: null,
      PO_BOX: null,
      ZIPCODE: null,
      POSTAL_CODE: null,
    };
  }

  getInvalidHighlightClass(fieldType: string): string {
    return this.fieldValidationState[fieldType] === false ? 'highlight-invalid-input' : '';
  }

  async getCommunityDetails(payload: {
    communityId: string;
    fieldType: string;
    residentId: string;
  }): Promise<any> {
    try {
      const response = await lastValueFrom(
        this.apiService.post({
          path: 'core/compliance-requirement/resident',
          data: payload,
          isAuth: true,
        }),
      );
      return response ?? false;
    } catch (error) {
      return false;
    }
  }

  checkEndDate(form: FormGroup, startControl: string, endControl: string): boolean {
    const startDate = form.controls[startControl].value;
    const endDate = form.controls[endControl].value;

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      if (end <= start) {
        form.controls[endControl].setValue(null);

        if (end < start) {
          this.toastr.error('End date cannot be earlier than start date.');
        } else {
          this.toastr.error('Start date and end date cannot be the same.');
        }

        return false;
      }
    }
    return true;
  }

  validateDateRange(startDate: string | null, endDate: string | null): boolean {
    if (!startDate && !endDate) {
      this.toastr.error('Both Start Date and End Date must be selected.');
      return false;
    }
    if (!startDate) {
      this.toastr.error('Start Date must be selected.');
      return false;
    }
    if (!endDate) {
      this.toastr.error('End Date must be selected.');
      return false;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (start > end) {
      this.toastr.error('End Date cannot be earlier than the Start Date.');
      return false;
    }

    return true;
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  convertArrayToClientObject(data: any[]): { [key: string]: number } {
    if (data) {
      return data.reduce(
        (acc, item) => {
          acc[item.ClientName] = item.Clientfees;
          return acc;
        },
        {} as { [key: string]: number },
      );
    }
    return {};
  }

  convertArrayToObject(data: any[]): { [key: string]: number } {
    if (data) {
      return data.reduce((acc, item) => {
        acc[item.PartnerName] = item.referral;
        return acc;
      }, {});
    }
  }

  syncQboPaymentStatus(
    selectedMonthYear: Date,
    communityId: string = '',
    portfolioId: string = '',
  ): Observable<{ empty: boolean; data: any[]; res: any }> {
    const request: any = {
      path: 'core/accounting-invoice/qbo-payment-status',
      data: {
        communityId,
        portfolioId,
        month: selectedMonthYear.getMonth() + 1,
        year: selectedMonthYear.getFullYear(),
      },
      isAuth: true,
    };
    return this.apiService.post(request).pipe(
      map((res: any) => {
        const ok = res?.status?.code === 'OK';
        const data: any[] = res?.data ?? res?.['data'] ?? [];
        const empty = ok && (!data || data.length === 0);

        if (ok) {
          if (empty) this.toastr.success(res?.status?.description);
        } else {
          this.toastr.error(res?.status?.description);
        }

        return { empty, data, res };
      }),
      catchError((err) => {
        // fallback error toast
        this.toastr.error(
          err?.error?.status?.description || err?.message || 'Something went wrong',
        );
        return throwError(() => err);
      }),
    );
  }

  refreshCommunityRequirements$ = this.refreshCommunityRequirementsSource.asObservable();

  triggerCommunityRequirementsRefresh(referenceId?: string, isFromLoad: boolean = true) {
    this.refreshCommunityRequirementsSource.next({ referenceId, isFromLoad });
  }
}
